module.exports = __webpack_public_path__ + "img/play-1.20b66ddc.png";